export class Receipt {
    constructor(
        public total?: number,
        public initiativeId?: number,
        public type?: number,
        public receiptDate?: string
        ) { }
}